import React from 'react';
import { Link } from "react-router-dom";

import {Poll, Chat, ReactionTriggers, Questions} from 'Components/MainStage';
import Authenticated from 'Components/Layouts/Authenticated';

import CelebrationWallTab from 'Pages/Cms/Elements/CelebrationWallTab';

import {translation} from 'Services/TranslationHelpers';

import Base from './Base';
import { asset } from "Services/BaseHelpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faCross, faTimes } from "@fortawesome/free-solid-svg-icons";
import { PrimaryButton } from "Components/Button";
import MainStageSurvey from "Pages/MainStage/MainStageSurvey";

export default class Remote extends Base {
    /**
     * @var success
     * @type {boolean}
     */
    remote_control = true;

    /**
     * @var state
     */
    state = {
        working: false,
        sessions: null,
        currentSession: null,
        currentPoll: null,
        showMenu: true,
        tab: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.mountBase();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        this.unmountBase();
    };

    /**
     * @method handleSetTab
     * @param {string} tab
     */
    handleSetTab = (tab) => {
        this.setState({
            tab,
            showMenu: false
        });
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {currentSession, tab, showMenu} = this.state;

        return (
            <Authenticated
                container={false}
            >
                {currentSession && (
                    <React.Fragment>
                        <div className={"w-full flex justify-center"}>
                            <PrimaryButton
                                onClick={() => this.setState({showMenu: true})}
                                text="Return to main menu"
                                className={"mx-auto"}
                            />
                        </div>

                        <div className="h-5/6 mt-8">
                            {tab === null && this.renderNoTab()}
                            {tab === 'chat' && this.renderChat()}
                            {tab === 'reactions' && this.renderReactions()}
                            {tab === 'polls' && this.renderPolls()}
                            {tab === 'questions' && this.renderQuestions()}
                            {tab === 'celebration-wall' && this.renderCelebrationWall()}
                            {tab === 'survey' && this.renderSurvey()}
                        </div>

                        {showMenu && (
                            <div className="absolute min-h-screen w-screen top-0 left-0 bg-app-blue-dark flex justify-center">
                                  <FontAwesomeIcon
                                      icon={faTimes}
                                      size="2x"
                                      onClick={() => this.setState({showMenu: false})}
                                      className="absolute  right-10 top-10 cursor-pointer  mr-2 text-white"
                                  />

                                <div className={"max-w-2xl mx-auto content-center"}>
                                    <div className="flex justify-center py-8">
                                        <img className="w-20" src={asset('images/header-logo.png')} alt="Boots and No7 logo" />
                                    </div>

                                    <div className="gap-8 grid grid-cols-2 w-full px-8 pb-8">
                                        {currentSession.chat && this.renderButton(translation('main_stage_frontend', 'chat_tab_text'), 'chat')}
                                        {currentSession.reactions && this.renderButton(translation('main_stage_frontend', 'reactions_tab_text'), 'reactions')}
                                        {currentSession.polls_enabled && this.renderButton(translation('main_stage_frontend', 'polls_tab_text'), 'polls')}
                                        {currentSession.questions && this.renderButton(translation('main_stage_frontend', 'questions_tab_text'), 'questions')}
                                        {this.renderButton(translation('main_stage_frontend', 'celebration_wall_tab_text'), 'celebration-wall')}
                                        {currentSession.survey && this.renderButton("Survey", 'survey')}
                                    </div>
                                </div>
                            </div>
                        )}
                    </React.Fragment>
                )}

                {!currentSession && (
                    <div className="h-full w-full flex justify-center items-center">
                        <p>{translation('main_stage_frontend', 'no_sessions_running')}</p>
                    </div>
                )}
            </Authenticated>
        );
    }

    /**
     * @method renderNoTab
     * @returns {JSX.Element}
     */
    renderNoTab = () => {
        return (
            <div className="h-full w-full flex justify-center items-center">
                {translation('main_stage_frontend', 'select_tab_get_started')}
            </div>
        );
    };

    /**
     * @method renderChats
     * @return {JSX.Element}
     */
    renderChat = () => {
        const {currentSession} = this.state;

        return (
            <div className="h-full w-full flex justify-center items-center">
                <Chat
                    sessionId={currentSession?.id}
                />
            </div>
        );
    };

    /**
     * @method renderReactions
     * @return {JSX.Element}
     */
    renderReactions = () => {
        const {currentSession} = this.state;

        return (
            <div className={"max-w-2xl flex p-10 justify-center gap-10 flex-wrap mx-auto content-center"}>
                <ReactionTriggers
                    sessionId={currentSession?.id}
                />
            </div>
        );
    };

    /**
     * @method renderPolls
     * @return {JSX.Element}
     */
    renderPolls = () => {
        const {currentPoll, currentSession} = this.state;

        if (!currentPoll) {
            return (
                <div className="h-full w-full flex justify-center items-center">
                    {translation('main_stage_frontend', 'no_polls')}
                </div>
            );
        }

        return (
            <div className="h-full w-full flex justify-center items-center">
                <Poll
                    poll={currentPoll}
                    sessionId={currentSession.id}
                />
            </div>
        );
    };

    /**
     * @method renderQuestions
     * @return {JSX.Element}
     */
    renderQuestions = () => {
        const {currentSession} = this.state;

        return (
            <div className="h-full w-full flex justify-between items-center">
                <Questions
                    sessionId={currentSession?.id}
                />
            </div>
        );
    };

    /**
     * @method renderCelebrationWall
     * @return {JSX.Element}
     */
    renderCelebrationWall = () => {
        return (
            <div className="h-full w-full flex justify-center items-center bg-gray-200 p-6">
                <CelebrationWallTab />
            </div>
        );
    }

    /**
     * @method renderButton
     * @param {string} text
     * @param {string} tab
     * @return {JSX.Element}
     */
    renderButton = (text, tab) => {
        const {tab: activeTab} = this.state;

        return (
            <div  className={`
                     p-4 rounded-xl flex justify-center
                    ${activeTab === tab ? 'bg-transparent text-white' : 'bg-app-blue-light text-white'}
                `}
                  onClick={() => this.handleSetTab(tab)}
            >
                <button
                    className={`
                    w-full  text-white
                    ${activeTab === tab ? 'bg-transparent text-white' : 'bg-app-blue-light text-white'}
                `}>
                    <img src={asset("images/remote/" + tab + ".png" )} className={"w-full my-auto mx-auto p-1"} />

                    {text}
                </button>
            </div>
        );
    };

    /**
     * @method renderSurvey
     * @returns {JSX.Element}
     */
    renderSurvey = () => {
        return (
            <MainStageSurvey currentSession={this.state.currentSession} />
        );
    };
}
